import React, {FC} from 'react';
import {Section} from 'templates/reports/query';
import Factoid from 'templates/reports/Section/Factoid';
import Posts from 'templates/reports/Section/Posts';
import {Section as Config} from 'templates/reports/types';

import {Chart} from './Chart';
import {Static} from './Static';
import {Table} from './Table';

import * as styles from './styles.module.scss';

type RmrEstimateProps = {
	cfg: Config['details']['historical']
	rmr: Section
}

export const RmrEstimate: FC<RmrEstimateProps> = ({cfg, rmr}) => {
	return (
		<div className={styles.wrapper}>
			<Static />
			<Chart cfg={cfg} rmr={rmr} />
			<Table rmr={rmr} />
			<Factoid
				title='RMR varies throughout your life'
				text='RMR changes due to muscle mass, body size, age, hormones, genes, diet, and environment. More muscle, larger body, and growth raise it. Aging, lower hormones, restricted calories, and inactivity reduce it. Genetics and cold exposure also affect metabolic rate.'
			/>

			{/* Use <span /> to skip applying standard styling */}
			<span>
				<Posts
					slugs={[
						'how_does_caffeine_affect_my_rmr',
						'all_about_the_rmr_test',
						'calculating_your_resting_metabolic_rate',
					]}
				/>
			</span>
		</div>
	);
};
